import React, { isValidElement } from 'react';
import { Tabs, TabList, Tab as Tab$1, VStack, Box, HStack, TabPanels, TabPanel, Spacer, Circle } from '@chakra-ui/react';
import { Icon } from '../Icon/component.js';
import { Typography } from '../Typography/component.js';

var Tab = function Tab(_ref) {
  var _ref$index = _ref.index,
      index = _ref$index === void 0 ? undefined : _ref$index,
      items = _ref.items,
      size = _ref.size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'line' : _ref$variant,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
      _onChange = _ref.onChange,
      icon = _ref.icon,
      _ref$defaultIndex = _ref.defaultIndex,
      defaultIndex = _ref$defaultIndex === void 0 ? 0 : _ref$defaultIndex,
      _ref$isFitted = _ref.isFitted,
      isFitted = _ref$isFitted === void 0 ? false : _ref$isFitted;

  if (!items || !!items && items.length === 0) {
    return null;
  }

  var getTitle = function getTitle(item, icon) {
    if (!icon) {
      return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
        textAlign: orientation === 'vertical' ? 'start' : 'center'
      }, item.title));
    }

    if (orientation === 'vertical') {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
        textAlign: "start"
      }, item.title), /*#__PURE__*/React.createElement(Spacer, null), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Circle, {
        bg: "#fff"
      }, item.isSelected && /*#__PURE__*/React.createElement(Icon, icon))));
    }

    return /*#__PURE__*/React.createElement(Box, {
      position: "relative"
    }, /*#__PURE__*/React.createElement(Box, {
      position: "absolute",
      bottom: "-15px",
      left: "50%",
      transform: "translateX(-50%)"
    }, /*#__PURE__*/React.createElement(Circle, {
      bg: "#fff"
    }, item.isSelected && /*#__PURE__*/React.createElement(Icon, icon))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
      textAlign: "center"
    }, item.title)));
  };

  return /*#__PURE__*/React.createElement(Tabs, {
    index: index,
    defaultIndex: defaultIndex,
    onChange: function onChange(index) {
      return _onChange(index);
    },
    isFitted: isFitted,
    orientation: orientation,
    variant: variant,
    size: size,
    align: "start",
    "data-object-type": "tab"
  }, /*#__PURE__*/React.createElement(TabList, null, items.map(function (item, i) {
    var key = "core-tab-header-".concat(item.title, "-").concat(i);
    return /*#__PURE__*/React.createElement(Tab$1, {
      key: key,
      "data-action-target": "tab",
      isDisabled: item.disabled
    }, !!item.icon && orientation === 'horizontal' && /*#__PURE__*/React.createElement(VStack, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Icon, item.icon)), getTitle(item, icon)), !!item.icon && orientation === 'vertical' && /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement(Icon, item.icon), getTitle(item, icon)), !item.icon && getTitle(item, icon));
  })), /*#__PURE__*/React.createElement(TabPanels, null, items.map(function (item, i) {
    if (!item || !item.children || ! /*#__PURE__*/isValidElement(item.children)) {
      return null;
    }

    var key = "core-tab-panel-".concat(item.title, "-").concat(i);
    return /*#__PURE__*/React.createElement(TabPanel, {
      key: key
    }, item.children);
  })));
};

Tab.displayName = "Tab";
export { Tab };